import { ReactNode, useState } from "react"

import Modal from "../modal/Modal";
import { createPortal } from "react-dom"
import "./help.css";

export default function Help({ title, children, color = "var(--green-medium)", className = "" }: 
    { title: string; children: ReactNode; color?: string; className?: string }) {
    const [modal, setModal] = useState(false);

    return (
        <div 
            className={`help-wrapper ${className}`}
            onClick={() => setModal(true)}
        >
            {/* version: "2.15" unicode: "fa3d" */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="3rem"
                height="3rem"
                viewBox="0 0 24 24"
                fill="currentColor"
            >
                <path 
                    className="help-icon" fill={color}
                    d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 13a1 
                    1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 
                    2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 
                    1.994a3 3 0 0 0 1.371 -5.673z" 
                />
            </svg>
            {modal && createPortal(
                <Modal
                    title={title}
                    onClose={() => setModal(false)}
                    isOpen={modal}
                    closeOnOverlayClick={true}
                >
                    {children}
                </Modal>,
                document.body
            )}
        </div>
    );
}